
























import Vue from 'vue';
import { Checkbox } from '@descomplica/vue-components';
import { CONTACT_METHODS } from '@/helpers/prouniOptions';
import { ProuniApplication } from '@/store/modules/prouni/types';

const CONTACT_SEPARATOR = ', ';

export default Vue.extend({
  name: 'ProuniAcceptanceForm',
  components: { Checkbox },
  props: {
    application: {
      type: Object as () => ProuniApplication | null,
      default: null,
    },
  },
  data() {
    const app = this.application || {};
    const selectedContacts = (app.contactMethod || '')
      .split(CONTACT_SEPARATOR)
      .map(value => value.trim())
      .filter(value => CONTACT_METHODS.includes(value));
    return {
      selectedContacts,
      form: {
        acceptedTerms: Boolean(app.acceptedTerms),
      },
    };
  },
  computed: {
    contactOptions(): string[] {
      return CONTACT_METHODS;
    },
  },
  mounted() {
    // Emit the initial validity so revisiting a step (already filled) enables Continue.
    this.inputHandler();
  },
  methods: {
    toggleContact(option: string, checked: boolean) {
      const selected = this.selectedContacts.filter(value => value !== option);
      if (checked) selected.push(option);
      // Keep the canonical option order regardless of click order.
      this.selectedContacts = CONTACT_METHODS.filter(value => selected.includes(value));
      this.inputHandler();
    },
    termsHandler(value: boolean) {
      this.form.acceptedTerms = value;
      this.inputHandler();
    },
    inputHandler() {
      const contactMethod = this.selectedContacts.join(CONTACT_SEPARATOR);
      // At least one contact method must be selected.
      const isValid = Boolean(this.selectedContacts.length && this.form.acceptedTerms);
      this.$emit('input', { ...this.form, contactMethod }, isValid);
    },
  },
});
